export default __webpack_public_path__ + "static/media/attendance-green-tick.05977bce.svg";